import { CommentActionTypes } from './constants';

const INIT_STATE = {
  comment_data: [],
  comment_data_by_id: null,
  loading: true,
  added: null,
  updated: null,
  deleted: null,
  error: null
};

const Comment = ( state = INIT_STATE, action ) => {
  switch(action.type) {
    case CommentActionTypes.API_RESPONSE_SUCCESS:   
      switch(action.payload.actionType) {
        case CommentActionTypes.GET_COMMENT:
          return {
            ...state,
            comment_data: action.payload.data.data,
            loading: false,
            error: null,
          }

        case CommentActionTypes.GET_COMMENT_BY_ID:
          return {
            ...state,
            comment_data_by_id: action.payload.data.data,
            loading: false,
            error: null,
          }
        
        case CommentActionTypes.ADD_COMMENT:
          return {
            ...state,
            added: action.payload.data.data,
            loading: false,
            error: null,
          }
        
        case CommentActionTypes.UPDATE_COMMENT:
          return {
            ...state,
            updated: action.payload.data.data,
            loading: false,
            error: null,
          }

        case CommentActionTypes.DELETE_COMMENT:
          return {
            ...state,
            deleted: action.payload.data.data,
            loading: false,
            error: null,
          }
        
        default:
          return { ...state };
      }

    case CommentActionTypes.API_RESPONSE_ERROR:
      switch(action.payload.actionType) {
        case CommentActionTypes.GET_COMMENT:
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          }

        case CommentActionTypes.GET_COMMENT_BY_ID:
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          }

        case CommentActionTypes.ADD_COMMENT:
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          }
        
        case CommentActionTypes.UPDATE_COMMENT:
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          }

        case CommentActionTypes.DELETE_COMMENT:
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          }
        
        default:
          return { ...state };
      }

      case CommentActionTypes.RESET_COMMENT:
        return { ...state, INIT_STATE }
      default:
        return { ...state, error: null }
      
  }
};

export default Comment;